export const COOKIE_ANALYTICS_NUM = 'Analytics-Page-Num';
export const COOKIE_ANALYTICS_ID = 'Analytics-Page-Id';
